/**
 * FF Media Gallery - Thumbnail-Based Navigation (v2 - Fixed)
 *
 * ROOT CAUSE OF PREVIOUS BUG:
 * Dawn hides other variants' thumbnails via CSS:
 *   .thumbnail-list_item--variant:not(:first-child) { display: none; }
 * But getThumbnails() was counting ALL thumbnails including hidden ones,
 * allowing arrow navigation to click hidden thumbnails whose slides had
 * been removed by updateMedia(). Dawn's fallback showed the first slide,
 * producing "empty" / duplicate images.
 *
 * FIX: Filter getThumbnails() to only return VISIBLE thumbnails.
 * Also use MutationObserver as backup re-init trigger (pubsub was unreliable).
 */

(function () {
  'use strict';

  // Prevent double-init and allow cleanup
  var currentCleanup = null;

  function initGallery() {
    // Clean up previous instance
    if (currentCleanup) {
      currentCleanup();
      currentCleanup = null;
    }

    var mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    var thumbnailContainer = mediaGallery.querySelector('[id^="GalleryThumbnails"]');
    var prevArrow = document.querySelector('.ff-media-arrow--prev');
    var nextArrow = document.querySelector('.ff-media-arrow--next');
    var arrowsContainer = document.querySelector('.ff-media-arrows');
    var hideAtEnds = arrowsContainer
      ? arrowsContainer.getAttribute('data-hide-at-ends') === 'true'
      : true;
    var zoomBtn = document.querySelector('.ff-zoom-icon');
    var slider = mediaGallery.querySelector('.product__media-list');

    // ═══════════════════════════════════════════════════════════════════════
    // THUMBNAIL-BASED NAVIGATION (Visible Thumbnails Only)
    // ═══════════════════════════════════════════════════════════════════════

    /**
     * KEY FIX: Only return thumbnails that are actually visible.
     *
     * Dawn's CSS hides other-variant thumbnails:
     *   .thumbnail-list_item--variant:not(:first-child) { display: none; }
     *
     * offsetParent === null for display:none elements, so this reliably
     * filters out hidden variant thumbnails without needing getComputedStyle.
     */
    function getVisibleThumbnails() {
      if (!thumbnailContainer) return [];
      var all = thumbnailContainer.querySelectorAll('.thumbnail-list__item');
      var visible = [];
      for (var i = 0; i < all.length; i++) {
        if (all[i].offsetParent !== null) {
          visible.push(all[i]);
        }
      }
      return visible;
    }

    function getCurrentThumbnailIndex() {
      var thumbnails = getVisibleThumbnails();
      var currentBtn = thumbnailContainer
        ? thumbnailContainer.querySelector('button[aria-current="true"]')
        : null;
      if (!currentBtn) return 0;

      var currentItem = currentBtn.closest('.thumbnail-list__item');
      var index = thumbnails.indexOf(currentItem);
      return index >= 0 ? index : 0;
    }

    function clickThumbnail(index) {
      var thumbnails = getVisibleThumbnails();
      if (index < 0 || index >= thumbnails.length) return;

      var button = thumbnails[index]
        ? thumbnails[index].querySelector('button.thumbnail')
        : null;
      if (button) {
        button.click();
      }
    }

    // ═══════════════════════════════════════════════════════════════════════
    // ARROW STATE & HANDLERS
    // ═══════════════════════════════════════════════════════════════════════

    function updateArrows() {
      if (!prevArrow || !nextArrow) return;

      var thumbnails = getVisibleThumbnails();
      var currentIndex = getCurrentThumbnailIndex();
      var maxIndex = thumbnails.length - 1;

      var atStart = currentIndex <= 0;
      var atEnd = currentIndex >= maxIndex || thumbnails.length <= 1;

      if (hideAtEnds) {
        // Hide arrows at ends — no looping
        prevArrow.classList.toggle('is-off', atStart);
        nextArrow.classList.toggle('is-off', atEnd);
        prevArrow.disabled = atStart;
        nextArrow.disabled = atEnd;
      } else {
        // Always show both arrows (looping enabled)
        prevArrow.classList.remove('is-off');
        nextArrow.classList.remove('is-off');
        prevArrow.disabled = false;
        nextArrow.disabled = false;
      }
    }

    function navigate(direction) {
      var thumbnails = getVisibleThumbnails();
      if (thumbnails.length === 0) return;

      var currentIndex = getCurrentThumbnailIndex();
      var newIndex = currentIndex + direction;

      if (hideAtEnds) {
        // Clamp — don't wrap
        if (newIndex < 0 || newIndex >= thumbnails.length) {
          updateArrows();
          return;
        }
      } else {
        // Wrap around for looping
        if (newIndex < 0) newIndex = thumbnails.length - 1;
        if (newIndex >= thumbnails.length) newIndex = 0;
      }

      pendingArrowDirection = direction; // tell slide animation which way to go
      clickThumbnail(newIndex);
      setTimeout(updateArrows, 100);
    }

    // ═══════════════════════════════════════════════════════════════════════
    // SETUP ARROW CLICK HANDLERS (onclick = safe for re-init, overwrites)
    // ═══════════════════════════════════════════════════════════════════════

    if (prevArrow) {
      prevArrow.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        navigate(-1);
        return false;
      };
    }

    if (nextArrow) {
      nextArrow.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        navigate(1);
        return false;
      };
    }

    // ═══════════════════════════════════════════════════════════════════════
    // ZOOM HANDLER — Desktop: single floating button
    // ═══════════════════════════════════════════════════════════════════════

    if (zoomBtn && slider) {
      zoomBtn.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        var activeSlide = slider.querySelector('.product__media-item.is-active');
        if (activeSlide) {
          var modalBtn = activeSlide.querySelector('.product__media-toggle');
          if (modalBtn) modalBtn.click();
        }
        return false;
      };
    }

    // ═══════════════════════════════════════════════════════════════════════
    // ZOOM HANDLER — Mobile: per-slide buttons injected into each opener
    // ═══════════════════════════════════════════════════════════════════════
    // Dawn's product__media-icon is a <span> (decorative only) and its
    // product__media-toggle covers the entire image (hijacks scroll).
    // We inject real <button> elements with our custom SVG into each
    // modal-opener. They're positioned absolute within the opener and
    // follow the image on swipe.

    if (window.innerWidth < 750 && slider) {
      // Get custom SVG from the floating zoom button (uses theme settings)
      var customSvg = zoomBtn ? zoomBtn.innerHTML : '';
      // Fallback SVG if floating button doesn't exist
      if (!customSvg) {
        customSvg = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/><path d="M11 8v6M8 11h6"/></svg>';
      }

      var slides = slider.querySelectorAll('.product__media-item');
      slides.forEach(function (slide) {
        var opener = slide.querySelector('.product__modal-opener');
        var toggle = slide.querySelector('.product__media-toggle');
        if (!opener || !toggle) return;

        // Don't duplicate on re-init
        if (opener.querySelector('.ff-mobile-zoom')) return;

        // Ensure opener is a positioning context
        opener.style.position = 'relative';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ff-mobile-zoom';
        btn.setAttribute('aria-label', 'Zoom image');
        btn.innerHTML = customSvg;

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggle.click();
        });

        opener.appendChild(btn);
      });
    }

    // ═══════════════════════════════════════════════════════════════════════
    // EVENT LISTENERS
    // ═══════════════════════════════════════════════════════════════════════

    // Thumbnail clicks — use onclick (overwrites cleanly on re-init)
    if (thumbnailContainer) {
      thumbnailContainer.onclick = function () {
        setTimeout(updateArrows, 100);
      };
    }

    // slideChanged — needs addEventListener (Dawn uses it internally),
    // tracked for cleanup to prevent duplicates
    var slideHandler = function (event) {
      // Sync .is-active to the currently visible slide.
      // On mobile, swiping doesn't update .is-active (only setActiveMedia does),
      // which causes the zoom button to open the wrong image in the modal.
      if (event && event.detail && event.detail.currentElement) {
        var currentSlide = event.detail.currentElement;
        if (slider && !currentSlide.classList.contains('is-active')) {
          slider.querySelectorAll('.product__media-item.is-active').forEach(function (el) {
            el.classList.remove('is-active');
          });
          currentSlide.classList.add('is-active');
        }
      }
      setTimeout(updateArrows, 50);
    };

    var viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      viewer.addEventListener('slideChanged', slideHandler);
    }

    // ═══════════════════════════════════════════════════════════════════════
    // MUTATION OBSERVER — Backup re-sync when slides change
    // ═══════════════════════════════════════════════════════════════════════
    // Catches variant changes even if PubSub doesn't reach us.
    // Watches for child additions/removals (updateMedia) and class
    // changes (setActiveMedia toggling .is-active).

    var mutationTimer = null;
    var observer = null;

    // ═══════════════════════════════════════════════════════════════════════
    // DESKTOP SLIDE TRANSITIONS — "REEL" STRIP
    // ═══════════════════════════════════════════════════════════════════════
    // Animates desktop image changes as a horizontal slide.
    //
    // APPROACH: positions all slides in the path (old + intermediates + new)
    // as a virtual strip using translateX offsets, then animates the entire
    // strip with a single CSS transition. Intermediates fly past as a blur
    // of content — no per-image easing, just one continuous motion.
    //
    // ADJACENT (1 step): strip of 2 slides, ease timing.
    // MULTI-STEP (thumbnail jump): strip of N+1 slides, ease timing.
    //   The ease curve naturally accelerates through intermediates and
    //   decelerates into the target — no stuttering.
    //
    // DIRECTION RULES:
    //   Arrow clicks: always continue in the arrow's direction (even when
    //     looping from last→first or first→last).
    //   Thumbnail clicks: always take the linear (non-wrapping) path.

    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
    var slideAnimating = false;
    var reelCleanupTimer = null;
    var animGeneration = 0; // prevents stale cleanup from interfering
    var lastActiveMediaId = null;
    var pendingArrowDirection = null; // set by navigate(), consumed by handleSlideTransition()
    var reelTotalDuration = 400; // ms — total time for any transition

    // Capture initial active slide
    if (isDesktop && slider) {
      var initActive = slider.querySelector('.product__media-item.is-active');
      if (initActive) lastActiveMediaId = initActive.dataset.mediaId || null;
    }

    function getSlideByMediaId(mediaId) {
      if (!mediaId || !slider) return null;
      return slider.querySelector('[data-media-id="' + mediaId + '"]');
    }

    function getMediaIdByThumbnailIndex(idx) {
      var thumbs = getVisibleThumbnails();
      if (idx >= 0 && idx < thumbs.length) return thumbs[idx].dataset.target;
      return null;
    }

    function getThumbnailIndexByMediaId(mediaId) {
      var thumbs = getVisibleThumbnails();
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].dataset.target === mediaId) return i;
      }
      return -1;
    }

    // ── Build the reel path (array of thumbnail indices to traverse) ──
    function buildReelPath(fromIdx, toIdx, forcedDirection) {
      var thumbs = getVisibleThumbnails();
      var n = thumbs.length;
      if (n === 0 || fromIdx === toIdx) return { path: [], direction: 0 };

      var direction;
      if (forcedDirection) {
        direction = forcedDirection;
      } else {
        direction = toIdx > fromIdx ? 1 : -1;
      }

      var path = [];
      var current = fromIdx;
      var safety = n + 1;
      while (safety-- > 0) {
        current = current + direction;
        if (forcedDirection) {
          current = (current + n) % n;
        }
        path.push(current);
        if (current === toIdx) break;
      }

      return { path: path, direction: direction };
    }

    // ── Cancel any in-progress animation ──
    function cancelSlideAnim() {
      if (!slider) return;
      animGeneration++;
      clearTimeout(reelCleanupTimer);

      var els = slider.querySelectorAll('.ff-slide-reel');
      for (var i = 0; i < els.length; i++) {
        els[i].style.transform = '';
        els[i].style.transition = '';
        els[i].classList.remove('ff-slide-reel');
      }
      slider.style.height = '';
      slideAnimating = false;
    }

    // ── Run the strip animation ──
    // Positions [old, intermediate1, ..., new] side by side as a virtual
    // strip, then translates them all in one continuous CSS transition.
    function runReel(oldMediaId, pathIndices, direction) {
      var numSteps = pathIndices.length;
      if (numSteps === 0) return;

      if (slideAnimating) cancelSlideAnim();
      slideAnimating = true;
      animGeneration++;
      var myGen = animGeneration;

      // Lock container height
      slider.style.height = slider.offsetHeight + 'px';

      // Build strip: [old, ...path slides]
      var stripMediaIds = [oldMediaId];
      for (var i = 0; i < numSteps; i++) {
        var mid = getMediaIdByThumbnailIndex(pathIndices[i]);
        if (mid) stripMediaIds.push(mid);
      }

      var stripSlides = [];
      for (var i = 0; i < stripMediaIds.length; i++) {
        var s = getSlideByMediaId(stripMediaIds[i]);
        if (!s) { cancelSlideAnim(); return; }
        stripSlides.push(s);
      }

      // Position each slide in the strip (no transition yet)
      // direction > 0 (forward): old=0%, int1=100%, int2=200%, new=N*100%
      // direction < 0 (backward): old=0%, int1=-100%, int2=-200%, new=-N*100%
      for (var i = 0; i < stripSlides.length; i++) {
        var s = stripSlides[i];
        s.style.transition = 'none';
        s.style.transform = 'translateX(' + (i * direction * 100) + '%)';
        s.classList.add('ff-slide-reel');
      }

      // Force reflow so starting positions take effect before transition
      void slider.offsetHeight;

      // Animate: shift entire strip so the last slide (new) lands at 0%
      var shift = -numSteps * direction * 100;

      // Duration scales logarithmically: 1 step = 400ms, 5 steps ≈ 500ms, 10 steps ≈ 540ms
      var dur = Math.round(reelTotalDuration + 60 * Math.log(numSteps));

      // Easing: single step gets standard ease. Multi-step gets progressively
      // stronger ease-out so deceleration into the target is more pronounced.
      // Blends from ease (0.25, 0.1, 0.25, 1) toward strong ease-out (0.12, 0.7, 0.12, 1).
      var easing = 'ease';
      if (numSteps > 1) {
        var t = Math.min((numSteps - 1) / 6, 1); // blend factor: 0 at 2 steps, 1 at 7+
        var p1 = 0.25 - 0.13 * t;  // 0.25 → 0.12
        var p2 = 0.1  + 0.6  * t;  // 0.1  → 0.7
        var p3 = 0.25 - 0.13 * t;  // 0.25 → 0.12
        easing = 'cubic-bezier(' + p1.toFixed(2) + ',' + p2.toFixed(2) + ',' + p3.toFixed(2) + ',1)';
      }

      for (var i = 0; i < stripSlides.length; i++) {
        var startPos = i * direction * 100;
        stripSlides[i].style.transition = 'transform ' + dur + 'ms ' + easing;
        stripSlides[i].style.transform = 'translateX(' + (startPos + shift) + '%)';
      }

      // Cleanup after transition completes
      reelCleanupTimer = setTimeout(function () {
        if (myGen !== animGeneration) return; // stale — newer anim took over
        for (var i = 0; i < stripSlides.length; i++) {
          stripSlides[i].style.transform = '';
          stripSlides[i].style.transition = '';
          stripSlides[i].classList.remove('ff-slide-reel');
        }
        slider.style.height = '';
        slideAnimating = false;
      }, dur + 50);
    }

    // ── Main handler: called by mutation observer when .is-active changes ──
    function handleSlideTransition() {
      if (!isDesktop || !slider) return;

      var newActive = slider.querySelector('.product__media-item.is-active');
      if (!newActive) return;

      var newMediaId = newActive.dataset.mediaId;
      if (!newMediaId || newMediaId === lastActiveMediaId) return;

      var oldMediaId = lastActiveMediaId;
      lastActiveMediaId = newMediaId; // always track latest

      var oldSlide = getSlideByMediaId(oldMediaId);
      if (!oldSlide) return; // first load or removed slide — skip animation

      // Determine indices
      var oldIdx = getThumbnailIndexByMediaId(oldMediaId);
      var newIdx = getThumbnailIndexByMediaId(newMediaId);
      if (oldIdx < 0 || newIdx < 0) return;

      // Consume pendingArrowDirection if set (arrow-initiated)
      var forcedDir = pendingArrowDirection;
      pendingArrowDirection = null;

      // Build path
      var reel = buildReelPath(oldIdx, newIdx, forcedDir);
      if (reel.path.length === 0) return;

      runReel(oldMediaId, reel.path, reel.direction);
    }

    if (slider) {
      observer = new MutationObserver(function () {
        // Immediate: slide animation (non-debounced)
        handleSlideTransition();

        // Debounced: arrow state + overflow check
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(function () {
          updateArrows();
          checkOverflow();
        }, 150);
      });
      observer.observe(slider, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    // ═══════════════════════════════════════════════════════════════════════
    // THUMBNAIL OVERFLOW DETECTION
    // ═══════════════════════════════════════════════════════════════════════
    // CSS defaults to justify-content: center. We ONLY add .has-overflow
    // (which switches to flex-start) when we're confident the layout is
    // stable and scrollWidth/clientWidth are accurate.
    //
    // NEVER run this check eagerly — on hard refresh, dimensions are
    // unreliable before images render and flex layout stabilizes.

    function checkOverflow() {
      if (!thumbnailContainer) return;
      var list = thumbnailContainer.querySelector('.thumbnail-list');
      if (!list) return;

      // Only trust dimensions when both are positive (layout has happened)
      if (list.scrollWidth <= 0 || list.clientWidth <= 0) return;

      var hasOverflow = list.scrollWidth > list.clientWidth + 2;
      thumbnailContainer.classList.toggle('has-overflow', hasOverflow);
      thumbnailContainer.classList.toggle('no-overflow', !hasOverflow);
    }

    // Schedule overflow check AFTER layout is stable:
    // - Wait for window load (all images rendered)
    // - Then wait one animation frame (layout/paint complete)
    function scheduleOverflowCheck() {
      requestAnimationFrame(function () {
        requestAnimationFrame(checkOverflow);
      });
    }

    if (document.readyState === 'complete') {
      // Already loaded (variant change re-init, or late script)
      scheduleOverflowCheck();
    } else {
      window.addEventListener('load', scheduleOverflowCheck, { once: true });
    }

    window.addEventListener('resize', checkOverflow);

    // Initial arrow state
    updateArrows();

    // ═══════════════════════════════════════════════════════════════════════
    // THUMBNAIL CAROUSEL — Frosted glass arrows + edge fade
    // ═══════════════════════════════════════════════════════════════════════

    var thumbPrevArrow = null;
    var thumbNextArrow = null;
    var thumbList = thumbnailContainer
      ? thumbnailContainer.querySelector('.thumbnail-list')
      : null;
    var thumbScrollHandler = null;
    var thumbResizeHandler = null;

    if (thumbnailContainer && thumbList) {
      // ── Inject frosted glass arrows (desktop) ──
      // Remove any previously injected arrows on re-init
      thumbnailContainer.querySelectorAll('.ff-thumb-arrow').forEach(function (el) {
        el.remove();
      });

      thumbPrevArrow = document.createElement('button');
      thumbPrevArrow.type = 'button';
      thumbPrevArrow.className = 'ff-thumb-arrow ff-thumb-arrow--prev is-off';
      thumbPrevArrow.setAttribute('aria-label', 'Previous thumbnails');
      thumbPrevArrow.innerHTML = '<span class="ff-thumb-arrow__icon" aria-hidden="true"></span>';

      thumbNextArrow = document.createElement('button');
      thumbNextArrow.type = 'button';
      thumbNextArrow.className = 'ff-thumb-arrow ff-thumb-arrow--next is-off';
      thumbNextArrow.setAttribute('aria-label', 'Next thumbnails');
      thumbNextArrow.innerHTML = '<span class="ff-thumb-arrow__icon" aria-hidden="true"></span>';

      thumbnailContainer.appendChild(thumbPrevArrow);
      thumbnailContainer.appendChild(thumbNextArrow);

      // Scroll by ~3 thumbnails worth
      function getThumbScrollStep() {
        var items = thumbList.querySelectorAll('.thumbnail-list__item');
        if (items.length === 0) return 200;
        var itemW = items[0].offsetWidth;
        var gap = parseFloat(getComputedStyle(thumbList).gap) || 10;
        return (itemW + gap) * 3;
      }

      thumbPrevArrow.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        thumbList.scrollBy({ left: -getThumbScrollStep(), behavior: 'smooth' });
      };

      thumbNextArrow.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        thumbList.scrollBy({ left: getThumbScrollStep(), behavior: 'smooth' });
      };

      // ── Scroll-based arrow visibility + fade ──
      // Read fade settings from CSS variables (set via theme editor)
      var sectionStyles = getComputedStyle(mediaGallery.closest('[id^="MainProduct"]') || document.documentElement);
      var fadeW = parseFloat(sectionStyles.getPropertyValue('--ff-thumb-fade-width')) || 40;
      var fadeOp = parseFloat(sectionStyles.getPropertyValue('--ff-thumb-fade-opacity'));
      if (isNaN(fadeOp)) fadeOp = 0; // 0 = fully transparent edge (strong fade)

      function updateThumbScroll() {
        var maxX = Math.max(0, thumbList.scrollWidth - thumbList.clientWidth);
        if (maxX <= 0) {
          // No overflow — hide everything
          if (thumbPrevArrow) thumbPrevArrow.classList.add('is-off');
          if (thumbNextArrow) thumbNextArrow.classList.add('is-off');
          thumbList.style.removeProperty('--ff-thumb-fadeL');
          thumbList.style.removeProperty('--ff-thumb-fadeR');
          thumbList.style.removeProperty('--ff-thumb-fadeLa');
          thumbList.style.removeProperty('--ff-thumb-fadeRa');
          return;
        }

        var x = Math.max(0, Math.min(thumbList.scrollLeft, maxX));
        var atStart = x <= 1;
        var atEnd = x >= maxX - 1;

        // Arrow hide-at-ends
        if (thumbPrevArrow) thumbPrevArrow.classList.toggle('is-off', atStart);
        if (thumbNextArrow) thumbNextArrow.classList.toggle('is-off', atEnd);

        // Fade calculation (for mask-image on both desktop and mobile)
        var leftProgress = Math.min(x / fadeW, 1);
        var rightProgress = Math.min((maxX - x) / fadeW, 1);

        // Eased fade
        var eL = 1 - (1 - leftProgress) * (1 - leftProgress);
        var eR = 1 - (1 - rightProgress) * (1 - rightProgress);

        thumbList.style.setProperty('--ff-thumb-fadeL', (eL * fadeW) + 'px');
        thumbList.style.setProperty('--ff-thumb-fadeR', (eR * fadeW) + 'px');
        // Edge alpha: fadeOp when at edge, 1 when scrolled away
        thumbList.style.setProperty('--ff-thumb-fadeLa', atStart ? '1' : String(fadeOp));
        thumbList.style.setProperty('--ff-thumb-fadeRa', atEnd ? '1' : String(fadeOp));
      }

      thumbScrollHandler = updateThumbScroll;
      thumbList.addEventListener('scroll', thumbScrollHandler, { passive: true });

      thumbResizeHandler = function () {
        checkOverflow();
        updateThumbScroll();
      };
      window.addEventListener('resize', thumbResizeHandler);

      // Initial state after layout
      function scheduleThumbUpdate() {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            checkOverflow();
            updateThumbScroll();
          });
        });
      }

      if (document.readyState === 'complete') {
        scheduleThumbUpdate();
      } else {
        window.addEventListener('load', scheduleThumbUpdate, { once: true });
      }
    }

    // ═══════════════════════════════════════════════════════════════════════
    // CLEANUP (called on re-init to prevent listener leaks)
    // ═══════════════════════════════════════════════════════════════════════

    currentCleanup = function () {
      if (observer) observer.disconnect();
      if (viewer) viewer.removeEventListener('slideChanged', slideHandler);
      if (thumbList && thumbScrollHandler) {
        thumbList.removeEventListener('scroll', thumbScrollHandler);
      }
      if (thumbResizeHandler) {
        window.removeEventListener('resize', thumbResizeHandler);
      }
      clearTimeout(mutationTimer);
      pendingArrowDirection = null;
      cancelSlideAnim();
    };
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // INITIALIZATION
  // ═══════════════════════════════════════════════════════════════════════════

  function init() {
    setTimeout(initGallery, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after variant changes via PubSub
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    if (PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(initGallery, 300);
      });
    }
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', init);
})();